<fw-dialog width="small">
  <fw-dialog-header>
    <h3>{{ 'createUserDialog.title' | translate }}</h3>
  </fw-dialog-header>
  <fw-dialog-content>
    <form [formGroup]="form">
      <fw-wrapped-input title="First Name" [errorText]="getErrorMessage('firstName', 'First Name')">
        <fw-text-input placeholder="Jane" formControlName="firstName"/>
      </fw-wrapped-input>
      <fw-wrapped-input title="Last Name" [errorText]="getErrorMessage('lastName', 'Last Name')">
        <fw-text-input placeholder="Doe" formControlName="lastName"/>
      </fw-wrapped-input>
      <fw-wrapped-input title="Email Address" [errorText]="getErrorMessage('emailAddress', 'Email Address')">
        <fw-text-input placeholder="name@example.com" formControlName="emailAddress"/>
      </fw-wrapped-input>
      <fw-wrapped-input title="Site Role">
        <fw-select
          test-id="site-role"
          formControlName="siteRole"
          width="100%">
          @for (role of siteRoleOptions; track role.value) {
            <fw-menu-item [title]="role.label" [value]="role.value" [disabled]="role.disabled" />
          }
          </fw-select>
      </fw-wrapped-input>
      <fw-wrapped-input *featureIf="['ldap_sync']" title="LDAP Sync ID" helperText="Cannot be changed once set" class="span-2">
        <fw-text-input placeholder="LDAP Sync ID" formControlName="ldap_sync_id" test-id="ldap"/>
      </fw-wrapped-input>
    </form>
  </fw-dialog-content>
  <fw-dialog-actions>
    <fw-button variant="outline" (click)="dialogRef.close()" test-id="cancel-button">
      Cancel
    </fw-button>
    <fw-button (click)="submit()" [disabled]="form.invalid" test-id="create-button">
      Save
    </fw-button>
  </fw-dialog-actions>
</fw-dialog>
